import React from 'react';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import Tooltip from 'src/components/Tooltip/Tooltip';

interface VisibilityPillProps {
  isExternallyVisible?: boolean | null;
}

const INTERNAL_PILL_COLOR: string = 'var(--color-status-negative)';
const EXTERNAL_PILL_COLOR: string = 'var(--color-status-positive)';

const INTERNAL_TOOLTIP_CONTENT: string =
  'Internal — hidden from homeowners and other external users. Visible only to staff (Property Developers and Admins).';
const EXTERNAL_TOOLTIP_CONTENT: string =
  'External — visible to the homeowner and other external users.';

const VisibilityPill = ({ isExternallyVisible }: VisibilityPillProps) => {
  if (isExternallyVisible == null) {
    return null;
  }

  const isInternal: boolean = isExternallyVisible === false;

  const label: string = isInternal ? 'Internal' : 'External';

  const color: string = isInternal ? INTERNAL_PILL_COLOR : EXTERNAL_PILL_COLOR;

  const iconGlyph: string = isInternal ? 'eye-slash' : 'eye';

  const tooltipContent: string = isInternal
    ? INTERNAL_TOOLTIP_CONTENT
    : EXTERNAL_TOOLTIP_CONTENT;

  return (
    <Tooltip content={tooltipContent}>
      <CategoryPill
        text={label}
        size="small"
        color={color}
        textColor="#fff"
        iconGlyph={iconGlyph}
        iconWeight="solid"
      />
    </Tooltip>
  );
};

export default VisibilityPill;